<template>
  <div>
    <Toolbar :handle-delete="del">
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item['@id']}`
        }}</v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-categoriepartenaire-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>

              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('nom') }}</strong></td>
              <td>
                                    {{ item['nom'] }}
              </td>
            
              <td><strong>{{ $t('priorite') }}</strong></td>
              <td>
                {{ $n(item['priorite']) }}              </td>
            </tr>
            
            <tr>
              <td><strong>{{ $t('partenaires') }}</strong></td>
              <td>
                                    {{ item['partenaires'].name }}
              </td>
            
              <td></td>
            </tr>
            
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'CategoriePartenaire';

export default {
  name: 'CategoriePartenaireShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields('categoriepartenaire', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('categoriepartenaire', ['find'])
  },
  methods: {
    ...mapActions('categoriepartenaire', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
